import {createReducer} from '@reduxjs/toolkit';

import {compare, select} from '../actions/mosaics';

export const initialState = {
  selected: '',
  comparing: '',
};

export default createReducer(initialState, {
  [select]: (state, {payload: selected}) => {
    state.selected = selected;
  },
  [compare]: (state, {payload: comparing}) => {
    state.comparing = comparing;
  },
});
